import { render, staticRenderFns } from "./DownloadGroupAttachments.vue?vue&type=template&id=095a8fbc"
import script from "./DownloadGroupAttachments.vue?vue&type=script&lang=js"
export * from "./DownloadGroupAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports